__webpack_require__.p = "https://static-prd.klouser.app/builds/klouser-ui-20260512-171818/";